import * as React from "react";
import "./App.css";
import AppRouter from "./routers/AppRouter";
import UserState from "./auth/UserState";
import NotificationState from "./components/toasts/NotificationState";


export default function App() {
  return (
    <div className="font-mulish">
      <UserState>
        <NotificationState>
          <AppRouter />
        </NotificationState>
      </UserState>
    </div>
  );
}